import { Component } from "react";

// Top-level safety net: React unmounts the whole tree on any uncaught
// render/effect error with no visible feedback in a production build (no
// dev error overlay there), which looks exactly like a stuck blank white
// screen to the user. This turns that into a visible, recoverable message
// instead of a silent blank page - and since it logs the error, it gives us
// something concrete to debug next time instead of guessing blind.
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Unhandled app error:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div data-testid="app-error-boundary" className="h-screen flex flex-col items-center justify-center gap-4 bg-background px-6 text-center">
          <p className="font-display text-2xl font-black">出错了 / Something went wrong</p>
          <p className="text-sm text-muted-foreground max-w-md break-words">{String(this.state.error?.message || this.state.error)}</p>
          <button
            data-testid="app-error-boundary-reload-button"
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-primary text-primary-foreground font-bold"
          >
            重新加载 / Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
